module.exports = __webpack_public_path__ + "static/media/contact-center.52399008.jpeg";